import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { formulariosColumns } from './columns/_columns'
import { FormularioList } from '../core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { Permission } from '../../../../../../_metronic/helpers'
import { useAuth } from '../../../../auth'
import { useT } from '_metronic/i18n/Metronici18n'

export const FormulariosTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const { currentUser } = useAuth()
  const { t } = useT()

  const isAdmin = currentUser?.grupo?.nome === Permission.Admin
  const columns = useMemo(() => formulariosColumns(t), [t])

  // Admin só lista com instituição; com filtro, oferece limpar; senão, vazio de cadastro.
  const emptyState =
    isAdmin && !filters.empresa ? (
      <TableEmptyState
        title={`Selecione uma ${t('empresa.label.lowercase')}`}
        description={`Os formulários são listados por ${t(
          'empresa.label.lowercase'
        )}. Escolha uma no filtro acima.`}
      />
    ) : hasFilters && (filters.formulario || filters.status) ? (
      <TableEmptyState
        title={
          filters.formulario
            ? `Nenhum formulário encontrado para “${filters.formulario}”`
            : 'Nenhum formulário com essa situação'
        }
        description='Revise o termo digitado ou a situação selecionada.'
        action={{ label: 'Limpar filtros', onClick: clearFilters }}
      />
    ) : (
      <TableEmptyState
        title='Nenhum formulário cadastrado'
        description='Use “Adicionar” para criar o primeiro formulário.'
      />
    )

  return (
    <CustomTable<FormularioList>
      id='kt_table_formularios'
      ariaLabel={t('formulario.plural')}
      itemLabel={{
        singular: t('formulario.label.lowercase'),
        plural: t('formulario.plural.lowercase'),
      }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
